import { render } from "./DeletionConfirm.vue?vue&type=template&id=f4cb3626"
import script from "./DeletionConfirm.vue?vue&type=script&lang=js"
export * from "./DeletionConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__